import { Numeric2BoxMultipleOutlineIcon } from './Numeric2BoxMultipleOutlineIcon';

/**
 * author: Google
 * id 989BAC0E-21F6-4AF2-849A-3DA35BA5958F
 * name numeric-2-box-multiple-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-2-box-multiple-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Filter2Icon = Numeric2BoxMultipleOutlineIcon;
export default Filter2Icon